module.exports = __webpack_public_path__ + "resources/img/img_i_onenet_en.753ad8dd21ec77a1e2665bc3502994e8.png";